var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoneCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 108L36.6666 84.6667C34.0666 82.0667 29.9333 82.0667 27.3333 84.6667C24.7333 87.2667 24.7333 91.4 27.3333 94L55.2666 121.933C57.8666 124.533 62.0666 124.533 64.6666 121.933L135.333 51.3334C137.933 48.7334 137.933 44.6 135.333 42C132.733 39.4 128.6 39.4 126 42L60 108Z",
    fill: "url(#paint0_linear_2165_10783)",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2165_10783",
    x1: 81.3333,
    y1: 40.05,
    x2: 81.3333,
    y2: 123.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoneCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/done-card.884ce5fd7399cf011134f7967d85b538.svg";